import { ReactComponent as ArrowRight } from '@basqet-dashboard/common/assets/icons/arrow-right.svg';
import { ReactComponent as DepositArrow } from '@basqet-dashboard/common/assets/icons/deposit-arrow.svg';
import { LoadingSettlementHistoryItem as LoadingPayoutHistoryItem } from '@basqet-dashboard/common/components';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { useFetchPayouts } from '../../../hooks/queries';

const PayoutRecentTransactions = () => {
  const { recentPayouts, isLoading } = useFetchPayouts();

  return (
    <div className="card payout__recent__transaction">
      <div className="card__header">
        <h3 className="card__title">
          Recent <span className="text-cursive">Transactions</span>
        </h3>
      </div>
      <ul className="payout__recent__transaction__list">
        {recentPayouts &&
          recentPayouts.map((transaction, index) => (
            <TransactionItem transaction={transaction} key={`payout_transaction-${index}`} />
          ))}

        {!recentPayouts.length && isLoading && (
          <>
            <LoadingPayoutHistoryItem />
            <LoadingPayoutHistoryItem />
          </>
        )}
      </ul>
      {!isLoading && recentPayouts.length > 0 && (
        <div className="card-footer">
          <Link to="/payouts/history" className="card__footer__link">
            See all payout <ArrowRight />
          </Link>
        </div>
      )}
      {!isLoading && !recentPayouts.length && (
        <div className="table__empty">
          <p>No data available</p>
        </div>
      )}
    </div>
  );
};

const TransactionItem = ({ transaction }) => {
  const created_at = format(new Date(transaction.created_at), 'dd - MM - yyyy');
  const { amount, currency, status, type } = transaction;
  const currency_slug = currency?.slug;

  return (
    <li className="payout__recent__transaction__list-item">
      <div className="leading">
        <DepositArrow className={type.toLowerCase()} />
        <div>
          <p className="payout__recent__transaction__type">{type}</p>
          <p className="payout__recent__transaction__amount">
            {amount} <span>{currency_slug}</span>
          </p>
        </div>
      </div>
      <div className="text-right">
        <span className={`payout__recent__transaction__status ${status.toLowerCase()}`}>
          {status}
        </span>
        <p className="payout__recent__transaction__date">{created_at}</p>
      </div>
    </li>
  );
};
TransactionItem.propTypes = {
  transaction: PropTypes.object
};

export { PayoutRecentTransactions };
